import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import '@sparta.global.vendors/lodash';
import { if_gteq, unless_gteq } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <h2 class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__heading\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":4,"column":54},"end":{"line":4,"column":66}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n      <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__content\">\r\n\r\n        <!-- First two questions --> \r\n        <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__items-row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"questionIDs") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":9,"column":10},"end":{"line":18,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n\r\n         <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__view-more\">\r\n          <button id=\"questionAndAnswerBtn\"\r\n                  class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__view-more-btn collapsed\"\r\n                  aria-expanded=\"false\"\r\n                  aria-controls=\"questionAndAnswerContent\">\r\n            <svg viewBox=\"0 0 20 20\" width=\"20\" height=\"20\" focusable=\"false\">\r\n              <polyline points=\"7.17 4.34 12.83 10 7.17 15.66\" style=\"fill:none;stroke:currentcolor;stroke-miterlimit:10;stroke-width:2px\"></polyline>\r\n            </svg>\r\n            <span class=\"expand\" tabindex=\"-1\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"expandBtnText") || (depth0 != null ? lookupProperty(depth0,"expandBtnText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"expandBtnText","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":29,"column":47},"end":{"line":29,"column":66}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"collapse hide\" tabindex=\"-1\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"collapseBtnText") || (depth0 != null ? lookupProperty(depth0,"collapseBtnText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"collapseBtnText","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":30,"column":54},"end":{"line":30,"column":75}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n          </button>\r\n        </div>\r\n\r\n        <!-- Hidden questions -->\r\n        <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item--hide\" id=\"questionAndAnswerContent\">\r\n          <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__hidden-questions\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"questionIDs") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":37,"column":12},"end":{"line":46,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"unless_gteq")||(depth0 && lookupProperty(depth0,"unless_gteq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),{"name":"unless_gteq","hash":{"compare":2},"fn":container.program(3, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":10,"column":12},"end":{"line":17,"column":28}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"questions")),blockParams[1][0],{"name":"lookup","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":12,"column":24},"end":{"line":12,"column":59}}}),{"name":"with","hash":{},"fn":container.program(4, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":12,"column":16},"end":{"line":15,"column":25}}})) != null ? stack1 : "")
    + "              </div>\r\n";
},"4":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <h3 class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item-question\">"
    + ((stack1 = container.lambda(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"question") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n                  <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item-answer\">"
    + ((stack1 = container.lambda(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"answer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"if_gteq")||(depth0 && lookupProperty(depth0,"if_gteq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),{"name":"if_gteq","hash":{"compare":2},"fn":container.program(7, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":38,"column":14},"end":{"line":45,"column":26}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__hidden-question-item\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"questions")),blockParams[1][0],{"name":"lookup","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":40,"column":26},"end":{"line":40,"column":61}}}),{"name":"with","hash":{},"fn":container.program(8, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":40,"column":18},"end":{"line":43,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n";
},"8":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <h3 class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item-question\">"
    + ((stack1 = container.lambda(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"question") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n                    <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__item-answer\">"
    + ((stack1 = container.lambda(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"answer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"columns small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pageContent") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":3,"column":4},"end":{"line":50,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"useData":true,"useBlockParams":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.falcon.modules/question-and-answer-module",
  "version": "1.0.4",
  "id": "questionAndAnswer",
  "containerID": "falconQuestionAndAnswerModule",
  "moduleName": "falcon-question-and-answer-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "question-and-answer-module",
  "data": {
    "init": "QuestionAndAnswer",
    "options": {}
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "description": "This parameter controls the general color scheme of module. The default is blue, but you can also choose red or green.",
    "default": "blue",
    "values": ["red", "green", "blue"]
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        if_gteq,
        unless_gteq
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    if_gteq,
    unless_gteq
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * The QuestionAndAnswer Sparta Module.
 * Q&amp;A that shows 2 questions and expands to show more.
 * Copy is shared but unique combination of questions appear on each page.
 * @export
 * @class
 */
class QuestionAndAnswer extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */
  init() {
    const viewMoreBtn = this.settings.target.querySelector('.question-and-answer-module__view-more-btn');
    const hiddenQuestions = this.settings.target.querySelectorAll('.question-and-answer-module__item--hide');
    if (viewMoreBtn && hiddenQuestions.length > 0) {
      viewMoreBtn.addEventListener('click', () => {
        this.expandCollapseQuestions(hiddenQuestions, viewMoreBtn);
      });
    } else {
      viewMoreBtn.classList.add('hide');
    }
    this.remainFocusOnClick(viewMoreBtn);
  }

  /**
   *
   * @description Expand and collapse Q&A hidden questions
   * @param {Array} questions array of questions
   * @param {Element} btn expand / collapse button
   * @memberof QuestionAndAnswer
   * @returns {undefined}
   */
  expandCollapseQuestions(questions, btn) {
    if (btn.classList.contains('collapsed')) {
      Array.from(questions).forEach(question => {
        question.classList.remove('question-and-answer-module__item--hide');
      });
      btn.classList.add('expanded');
      btn.classList.remove('collapsed');
      btn.querySelector('.collapse').classList.remove('hide');
      btn.querySelector('.expand').classList.add('hide');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      Array.from(questions).forEach(question => {
        question.classList.add('question-and-answer-module__item--hide');
      });
      btn.classList.remove('expanded');
      btn.classList.add('collapsed');
      btn.querySelector('.collapse').classList.add('hide');
      btn.querySelector('.expand').classList.remove('hide');
      btn.setAttribute('aria-expanded', 'false');
    }
  }
  remainFocusOnClick(bttn) {
    bttn.addEventListener('click', () => {
      if (/iPhone/i.test(navigator.userAgent)) {
        setTimeout(() => {
          bttn.focus();
        }, 0);
      }
    });
  }
}
registerModuleClass({
  moduleClass: QuestionAndAnswer,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { QuestionAndAnswer as default, moduleConfig };
